module.exports = __webpack_public_path__ + "static/media/screenshot.3135a8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/camry/screenshot.png
// module id = 819
// module chunks = 0